let BACKEND_API_URL = 'http://46.182.172.161:8085/';
BACKEND_API_URL = 'https://api.dotigo.net';

// let DISPLAY_LANG = 'en';
let DISPLAY_LANG = 'ru';
// DISPLAY_LANG = 'am';

export {
    DISPLAY_LANG,
    BACKEND_API_URL,
};
